import { createAsyncThunk } from "@reduxjs/toolkit";
import NeweraRequestService from "services/newera/neweraRequestService";
import { buildErrorDisplayMessage } from "utils/errorMessageBuilder";
import { ProfileInformationConstant } from "../../constants";

export const updateInsuranceCompanyDetails = createAsyncThunk(
  `${ProfileInformationConstant.StoreSliceName}/updateInsuranceCompanyDetails`,
  async (payload, {rejectWithValue }) => {
    try {
      const result =  await NeweraRequestService.updateInsuranceCompanyDetails(payload);
      return result
    } catch (error) {
      const errorDisplayMessage = buildErrorDisplayMessage(error);
      throw rejectWithValue(errorDisplayMessage);
    }
  }
);
